module.exports = __webpack_public_path__ + "static/media/施工後.d53e056b.jpg";